// Copyright 2019, White Label Communications, LLC, All rights reserved.

import React from 'react';
import {
  Container,
  Row,
  Col,
  Table,
  Pagination,
  Button,
} from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import DashBoard from 'components/Layout/Dashboard';
import Layout from 'components/Layout/Layout';
import Picker from 'components/Common/DateRange/Picker';
import Download from 'images/download.svg';
import BillingIcon from 'images/money.svg';
import ActivityList from './components/ActivityList';

export default class ActivityLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startValue: moment(),
      endValue: moment().add(5, 'days'),
      startOpen: false,
      endOpen: false,
    };
  }

  onStartOpenChange = (startOpen) => {
    this.setState({
      startOpen,
    });
  };

  onEndOpenChange = (endOpen) => {
    this.setState({
      endOpen,
    });
  };

  onStartChange = (value) => {
    this.setState({
      startValue: value[0],
      startOpen: false,
      endOpen: true,
    });
  };

  onEndChange = (value) => {
    this.setState({
      endValue: value[1],
    });
  };

  disabledStartDate = (endValue) => {
    if (!endValue) {
      return false;
    }
    const { startValue } = this.state;
    if (!startValue) {
      return false;
    }
    return endValue.diff(startValue, 'days') < 1;
  };

  render() {
    const {
      startValue,
      startOpen,
      endOpen,
      endValue,
    } = this.state;
    return (
      <Layout>
        <DashBoard>
          <div className="billing">
            <div className="title-section">
              <h2>
                <img src={BillingIcon} alt="boomea" />
                BILLING
              </h2>
            </div>
            <div className="manage-users-table">
              <div className="billing-header">
                <Container fluid>
                  <Row>
                    <Col md={12}>Activiy Log</Col>
                  </Row>
                </Container>
              </div>
              <div className="manage-area activity-log">
                <Container fluid>
                  <Row>
                    <Col md={5}>
                      <table className="daterange-table">
                        <tbody>
                          <tr className="no-border">
                            <td style={{ width: '55px' }}>Form:</td>
                            <td style={{ width: '150px' }}>
                              <Picker
                                onOpenChange={this.onStartOpenChange}
                                type="start"
                                showValue={startValue}
                                open={startOpen}
                                value={[startValue, endValue]}
                                onChange={this.onStartChange}
                                Placeholder="Start Date"
                                className="date-picker"
                              />
                            </td>
                            <td style={{ width: '35px' }}>To:</td>
                            <td style={{ width: '150px' }}>
                              <Picker
                                onOpenChange={this.onEndOpenChange}
                                open={endOpen}
                                type="end"
                                showValue={endValue}
                                disabledDate={this.disabledStartDate}
                                value={[startValue, endValue]}
                                onChange={this.onEndChange}
                                className="date-picker"
                              />
                            </td>
                            <td>
                              <Button variant="blue">GO</Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                    <Col md={{ offset: 1, span: 3 }}>
                      <Button variant="blue download-invoice">
                        <img src={Download} alt="boomea" />
                        DOWNLOAD LOG
                        {' '}
                      </Button>
                    </Col>
                    <Col md={{ span: 3 }}>
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search"
                      />
                    </Col>
                    <Col md={12}>
                      <PerfectScrollbar className="scroll-area">
                        <div className="table-area">
                          <Table>
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Description</th>
                                <th className="text-right">Year: 2019</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ActivityList />
                              <ActivityList />
                              <ActivityList />
                            </tbody>
                          </Table>
                        </div>
                      </PerfectScrollbar>
                      <Pagination
                        size="sm"
                        className="d-flex justify-content-end"
                      >
                        <Pagination.Prev />
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item>{2}</Pagination.Item>
                        <Pagination.Item>{3}</Pagination.Item>
                        <Pagination.Item>{4}</Pagination.Item>
                        <Pagination.Item>{5}</Pagination.Item>
                        <Pagination.Next />
                      </Pagination>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </DashBoard>
      </Layout>
    );
  }
}
